import React, { createContext, useContext, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { HomeDashboard } from './components/home/home';
import { AssetList } from './components/asset/assetList/AssetList';
import { Layout, LayoutWithoutSideBar } from '../src/layout';
import { TaxDetails } from './components/asset/taxDetails/TaxDetails';
import { FinancialStatement } from './components/asset/financialstatement/FinancialStatement';
// import { Holdings } from './components/asset/holdings/Holdings';
import { AssetEdit } from './components/asset/assetEdit/AssetEdit';
import { AssetAdd } from './components/asset/assetEdit/AssetAdd';
import { ShareClassAdd } from './components/asset/assetAdd/AssetShareClassAdd';
import { ReturnsAndStatistics } from './components/asset/returnsandstatistics/ReturnsAndStatistics';
import { AssetSettingsPage } from './components/asset/assetSettings/AssetSettings';
import { AssetDetails } from './components/asset/assetDetail/AssetDetails';
import { UrlPath } from './config/routeConfig';
import { ErrorPage } from './components/shared/ErrorPage/ErrorPage';
// import Test  from './components/asset/test';
import { ShareClassEdit } from './components/asset/assetEdit/ShareClassEdit';
import { AttributesEdit } from './components/asset/attributes/AttributesEdit';
import { AttributesAdd } from './components/asset/attributes/AttributesAdd';
import { Profile } from './components/home/profile';
import { Investment } from './components/library/EnhancedLibrary/Investment';
import { InvestmentEdit } from './components/library/EnhancedLibrary/InvestmentEdit';
import { InvestmentAddView } from './components/library/EnhancedLibrary/InvestmentAdd';
import { UniverseList } from './components/analyticsReoporting/peerAnalytics/universeList/UniverseList';
import { UniverseDetails } from './components/analyticsReoporting/peerAnalytics/universeDetails/UniverseDetails';
import { PrivateExposure } from './components/asset/exposures/privateExposure/Private';
import { PublicExposure } from './components/asset/exposures/publicExposure/Public';
import { UniverseDetailsEdit } from './components/analyticsReoporting/peerAnalytics/universeEdit/UniverseEdit';
import { UniverseDetailsAdd } from './components/analyticsReoporting/peerAnalytics/universeAdd/UniverseAdd';
import { getDefaultEntities, getUserDetails } from './components/actions/CommonAction';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from "@azure/msal-react";
import { EmailRulesList } from './components/asset/emailRules/EmailRules';
import { AddEmailRules } from './components/asset/emailRules/AddRules';
import { EditEmailRules } from './components/asset/emailRules/EditRules';
import { AUMList } from './components/asset/assetDetail/AssetAUM/AUMList';
import { PostPricing } from './components/asset/returnsandstatistics/postpricing/PostPricing';
import { Permissions } from './components/admin/Permissions';
import { UserPageTracking } from './components/admin/userPageTrackingReport/UserPageTracking';
import { UsersLastLogin } from './components/admin/userLastLogin/UsersLastLogin';
import { ClientReportingSettings } from './components/admin/clientReportSetting/ClientReportingSetting';
import { callMsGraph } from './authConfig';
import { getAuthorizationToken } from './components/actions/getAuthorizationToken';
import { MarketDataList } from './components/analyticsReoporting/peerAnalytics/marketData/MarketDataList';
import { MarketAnalytics } from './components/analyticsReoporting/peerAnalytics/marketData/Analytics/MarketAnalytics';
import { MarketDataDetails } from './components/analyticsReoporting/peerAnalytics/marketData/MarketDataDetails';
import { MarketDataEdit } from './components/analyticsReoporting/peerAnalytics/marketData/MarketDataEdit';
import { MarketDataAdd } from './components/analyticsReoporting/peerAnalytics/marketData/MarketDataAdd';
import { MarketAnalyticsPostPricing } from './components/analyticsReoporting/peerAnalytics/marketData/Analytics/postpricing/PostPricing';
import { MarketDataSettings } from './components/analyticsReoporting/peerAnalytics/marketData/MarketDataSettings';
import { ProtectedRoute } from './components/shared/Protected';
import { CompanyContactsList } from './components/investor/companyList/CompanyContactsList';
import { Details } from './components/investor/investorDetails/Details';
import { CompanyDetails } from './components/investor/companyDetails/Details';
import { ContactsEdit } from './components/investor/investorDetails/contactInfo/ContactsEdit';
import { CompanyEdit } from './components/investor/companyDetails/companyInfo/CompanyEdit';
import { LandingPage } from './components/shared/LandingPage';
import { Lists } from './components/investor/lists/Lists';
import { ProformaConstruction } from './components/analyticsReoporting/peerAnalytics/proformaConstruction/ProformaConstruction';
import { CreateNewProformas } from './components/analyticsReoporting/peerAnalytics/proformaConstruction/existingProformas/CreateNewProformas';
import { AnalystExposure } from './components/asset/exposures/analystExposure/analyst';
import { UniverseAnalytics } from './components/analyticsReoporting/peerAnalytics/universeAnalytics/UniverseAnalytics';
import { Valuation } from './components/Portfolio/Valuation';
import { Pricing } from './components/Portfolio/Pricing';
import { AssetAUMList } from './components/Portfolio/AssetAum';
import { TransactionList } from './components/asset/transactions/TransactionList';
import { Commitment } from './components/transactions/commitment/Commitment';
import { Allocation } from './components/transactions/allocation/Allocation';
import { AddToPortfolio } from './components/transactions/addToPortfolio/AddToPortfolio';
import { Redemption } from './components/transactions/redemption/Redemption';
import { Distribution } from './components/transactions/distribution/Distribution';
import { ReceiveCash } from './components/transactions/receiveCash/ReceiveCash';
import { Payout } from './components/transactions/payOut/Payout';
import { getLeftMenuSection } from './components/actions/leftMenuAction';
import { Reporting } from './components/reporting/Reporting';
import { Liquidity } from './components/asset/liquidity/liquidity';
import { InvestorTrackingList } from './components/investor/investorTracking/InvestorTracking';
import { Investor } from './components/library/InvestorLibrary/Investor';
import { InvestorAdd } from './components/library/InvestorLibrary/InvestorAdd'
import { InvestorEdit } from './components/library/InvestorLibrary/InvestorEdit'
import { InvestorAccounts } from './components/investor/investorAccounts/InvestorAccounts';
import { InvestorAccountsDetails } from './components/investor/investorAccounts/InvestorAccountDetails';
import { InvestorAccountEdit } from './components/investor/investorAccounts/InvestorAccountEdit';
import { InvestorAccountAdd } from './components/investor/investorAccounts/InvestorAccountAdd';
import { Tasks } from './components/investor/tasks/Tasks';
import CSDetails from './components/investor/clientStatements/Details';
import { PortfolioList } from './components/Portfolio/portfolioList/portfolioList';
import { PortfolioDetails } from './components/Portfolio/portfolioDetails/portfolioDetails';
import { ValuationPostPricing } from './components/Portfolio/PostPricing';
import { sbaAxios } from './components/utils/sbaAxios';
import { genAIHealth, getUserPageAccess, notificationHubService, updatePageTrackingAPI,getUnreadNotifications } from './config/apiConfig';
import { PortfolioTransaction } from './components/Portfolio/transaction/transactionList';
import { PortfolioAttribution } from './components/Portfolio/portfolioAttribution/portfolioAttribution';
import { CapitalCall } from './components/transactions/capitalCall/CapitalCall';
import { JournalEntry } from './components/transactions/journalEntry/JournalEntry';
import { Opportunities } from './components/investor/opportunities/Opportunities';
import { EmailMarketing } from './components/investor/emailNotifications/EmailMarketing';
import { ApplicationSettings } from './components/admin/ApplicationSettings/ApplicationSettings';
import { Classfications } from './components/admin/Classifications/classifications';
import { ServerInfo } from './components/admin/ServerInfo/ServerInfo';
import { MarketablePostPricing } from './components/Portfolio/MarketablePostPricing';
import { Billing } from './components/admin/Billing/Billing';
import { WebPortalSync } from './components/admin/WebPortalSync/WebPortalSync';
import MarketableSecuritiesFeed from './components/admin/MarketableSecurities/MarketableSecurities';
import { BillingPreviewSection } from './components/admin/Billing/Tab/BillingTab/Generate';
import { ClientWebsite } from './components/admin/ClientWebsite/clientWebsite';
import { Partnership } from './components/admin/Partnerships/Partnership';
import { PartnershipSetup } from './components/admin/Partnerships/PartnershipSetup';
/*import { useMsal } from "@azure/msal-react";*/
import { useIsAuthenticated } from "@azure/msal-react";
import RequireAuth from '../src/requireAuth'
import { Duediligence } from './components/asset/duedilligence/Duedilligence';
import DDQSetup from './components/admin/DDQ_Setup/DDQSetup';
import { PPLISetup } from './components/admin/Partnerships/PPLISetup';
import { ITSubscription } from './components/investor/investorTracking/ITSubscription';
import { HelpPage } from './components/shared/HelpPage';
import { ITRedemption } from './components/investor/investorTracking/ITRedemption';
import { ITCommitment } from './components/investor/investorTracking/ITCommitment';
import { ITCapitalCall } from './components/investor/investorTracking/ITCapitalCall';
import { ITDistribution } from './components/investor/investorTracking/ITDistribution';
import { BulkUpload } from './components/investor/investorTracking/BulkUpload';
import { ITRedeemFee } from './components/investor/investorTracking/ITRedeemFee';
import { ITRedeemReallocate } from './components/investor/investorTracking/ITRedeemReallocate';
import { ChatBot } from './components/chatbot_v2/Chatbot';
//import { GenAIPrompts } from './components/admin/GenAI/GenAIPrompts';
import Settings from './components/home/Settings';
import Custodians from './components/admin/custodians/Custodians';
import { LoadingScreen } from './components/UiComponents/LoadingComponent';
import TrainModel from './components/admin/trainModel/TrainModel';
import { GenAITabs } from './components/admin/GenAI/GenAITabs';
import { AssetAllocation } from './components/Portfolio/assetAllocation/AssetAllocation';
import { MonitoringView } from './components/admin/Monitoring Exception/MonitoringView';
import { MonitoringSettingsView } from './components/admin/MonitoringExceptionSettings/MonitoringSettingsView';
import { MonitoringExceptionType } from './components/admin/MonitoringExceptionSettings/MonitoringExceptionType';
import { MonitoringNotificationDetails } from './components/admin/MonitoringExceptionSettings/MonitoringNotificationDetails';
import { CilentReturnsAnalytics } from './components/clientReturns/analytics/CilentReturnsAnalytics';
import { CilentReturnsDetails } from './components/clientReturns/detail/CilentReturnsDetails';
import { ClientReturnsList } from './components/clientReturns/list/ClientReturnsList';
import PerfAndStats from './components/Portfolio/performanceAndStatistics/PerfAndStats';
import { ThirdPartyData } from './components/analyticsReoporting/thirdPartyData/thirdPartyDataList/ThirdPartyData';
import { ThirdPartyDataDetails } from './components/analyticsReoporting/thirdPartyData/details/Details';
import { ThirdPartyDataAnalytics } from './components/analyticsReoporting/thirdPartyData/analytics/Analytics';
import NotificationConsole from './components/admin/Notification/Notification';
import NotificationComponent, { NotificationDrawer } from './components/shared/NotificationManager';
import * as signalR from "@microsoft/signalr";

export const loginRequest = {
    scopes: ["User.Read"]
};

const NotificationContext = createContext();


export const ContentRoutes = () => {
    const { instance, accounts } = useMsal();
    const location = useLocation();
    const Lander = useSelector(state => state.authorizationData.landingPage);
    const [viewAccess, setViewAccess] = useState(false);
    const [chatAccess, setChatAccess] = useState(false);
    const [isAppLoaded,setIsAppLoaded]=useState(false);
    const [notifications, setNotifications] = useState([]);
    const [showNotification,setShowNotification]=useState(false);
    const [showNotificationDrawer,setShowNotificationDrawer]=useState(false);

    const loggedAccount = instance.getAllAccounts()[0];
    const dispatch = useDispatch();
    const getLatestNotifications = async()=> {
        const lst = await sbaAxios({
            url: getUnreadNotifications
        })

        const unreadList = lst?.map(n => {
            const sentTime = new Date(n.SentTime+'Z'); //utc parsing
    
            return {
                message: n.Message,
                header: n.Header,
                userName: n.userName,
                time: sentTime,
                userId: n.SentBy,
                nId: n.NotificationId,
                nRefNum: n.NotificationRefNumber,
                isRead: n.IsRead
            };
        });
    
          // Prepend or merge with existing notifications
          setNotifications(val => [...unreadList]);
    };
    const dispatchActions = async () => {
        try {
            // Attempt to get idToken from sessionStorage
            let idToken = localStorage.getItem('idToken');

            // If idToken is not in sessionStorage, use the one from loggedAccount
            if (!idToken && accounts[0]?.username) {
                idToken = loggedAccount.idToken;

                // Store the idToken in sessionStorage for persistence
                localStorage.setItem('idToken', idToken);
            }


            // Dispatch actions
            if (idToken) {
                dispatch(getAuthorizationToken(accounts[0].username, idToken));
                setTimeout(() => {
                    dispatch(getUserDetails(accounts[0].username));
                    dispatch(getDefaultEntities());
                    getChatBotAccess();
                    getLatestNotifications();
                    setIsAppLoaded(true);
                }, 500);
            }
        } catch (error) {
            console.error('Error in dispatchActions:', error);
        }
    };
    const getChatBotAccess = () => {
        sbaAxios({ url: `${getUserPageAccess}?keyName=ChatBotViewAccess` }).then(res => {
            sbaAxios({ url: genAIHealth }).then(res => { setChatAccess(res?.status == 'ok') }).catch(() => { setChatAccess(false) })
            setViewAccess(res);
        }).catch(er => {
            setViewAccess(false);
        });
    };
    useEffect(() => {
        setTimeout(() => {
            updatePageTracking(Lander);
        }, 500);
    }, [location]);

    useEffect(() => {
        dispatchActions();
    }, []);
    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
          .withUrl(notificationHubService, {
            accessTokenFactory: () => localStorage.getItem("idToken") || loggedAccount.idToken, // must be valid JWT
            //withCredentials: true
          })
          .withAutomaticReconnect()
          .build();
        connection.start()
        .then(async () => {
            console.log("SignalR connected");
      
            connection.invoke("GetConnectionId")
  .then(connectionId => {
    console.log("Connection ID:", connectionId);
    localStorage.setItem("signalRConnectionId", connectionId);
  })
  .catch(err => {
    console.error("Error getting connection ID:", err);
  });
          })
          .catch(err => console.error("SignalR connection error:", err));
      
        connection.on("ReceiveNotification", (data) => {
          setNotifications(val => [{message:data?.message,header:data?.header,userName:data?.userName,time:new Date(),userId:data?.userId, nId:data?.notificationId, nRefNum:data?.notificationRefNumber},...val]);  
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(val => false)
          }, 5000);
        });
    
        return () => {
          connection.stop();
        };
      }, []);

    //    console.log('Already Have the Token');
    //    const isAuthenticated = useIsAuthenticated();
    //    console.log('IsAuthenticated', isAuthenticated)
    //    const { instance } = useMsal();

    //    useEffect(() => {
    //        if (!isAuthenticated) {
    //            // Clear session storage and local storage for a fresh login
    //            sessionStorage.clear();
    //            localStorage.clear();

    //            // Trigger Microsoft Authentication
    //            instance.loginPopup(loginRequest).catch((e) => {
    //                console.error("Login failed:", e);
    //            });
    //        }
    //    }, [isAuthenticated, instance]);

    //    if (!isAuthenticated) {
    //        return <p>Redirecting to login...</p>;
    //    }

    //    return <>{children}</>;
    //};
    return (
        <>
        {!isAppLoaded ? <><LoadingScreen/></>: <NotificationContext.Provider value={{ notifications, setNotifications , showNotificationDrawer ,setShowNotificationDrawer}}>
        <Routes>
             <Route path="/Helper" element={<><LayoutWithoutSideBar/></>}>
                <Route path={`${UrlPath.Help}`} element={<HelpPage/>} />
            </Route>
            <Route path="/" element={<Layout />}>
                <Route index element={<LandingPage />} />
                {/* Home */}
                <Route path={`${UrlPath.Home}`} element={<ProtectedRoute name={'Home'}><HomeDashboard /></ProtectedRoute>} />
                <Route path={`${UrlPath.Profile}`} element={<Profile />} />
                {/* Asset */}
                <Route path={`${UrlPath.Asset}`} element={<ProtectedRoute name={'Asset'}><AssetList /></ProtectedRoute>} />
                {/* Asset-- Details */}
                <Route path={`${UrlPath.AssetDetails}:Asset`} element={<ProtectedRoute name={'Details'}><AssetDetails /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetTaxDetails}:Asset`} element={<ProtectedRoute name={'Tax'}><TaxDetails /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetFinancialStatement}:Asset`} element={<ProtectedRoute name={'Financial Statements'}><FinancialStatement /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetEdit}:Asset`} element={<ProtectedRoute name={'Details'}><AssetEdit /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetAdd}`} element={<ProtectedRoute name={'Details'}><AssetAdd /></ProtectedRoute>} />
                <Route path={`${UrlPath.AUMList}:AssetId`} element={<ProtectedRoute name={'Details'}><AUMList /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetSetting}:Asset`} element={<ProtectedRoute name={'Details'}><AssetSettingsPage /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetShareClassEdit}:Asset/:ShareClassID`} element={<ProtectedRoute name={'Details'}><ShareClassEdit /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetShareClassAdd}:Asset`} element={<ProtectedRoute name={'Details'}><ShareClassAdd /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetAttributesEdit}:Asset`} element={<ProtectedRoute name={'Details'}><AttributesEdit /></ProtectedRoute>} />
                <Route path={`${UrlPath.AssetAttributesAdd}:Asset`} element={<ProtectedRoute name={'Details'}><AttributesAdd /></ProtectedRoute>} />
                {/* <Route path={`${UrlPath.Liquidity}:Asset`} element={<ProtectedRoute name={'Details'}><Liquidity /></ProtectedRoute>} /> */}
                {/* Asset-- Analytics */}
                <Route path={`${UrlPath.AssetReturnStatics}:Asset`} element={<ProtectedRoute name={'Analytics'}><ReturnsAndStatistics /></ProtectedRoute>} />
                <Route path={`${UrlPath.PostPricing}:Asset`} element={<ProtectedRoute name={'Analytics'}><PostPricing /></ProtectedRoute>} />
                {/* Asset-- EmailRules */}
                <Route path={`${UrlPath.EmailRulesList}:Asset`} element={<ProtectedRoute name={'Email Rules'}><EmailRulesList /></ProtectedRoute>} />
                <Route path={`${UrlPath.AddEmailRules}`} element={<ProtectedRoute name={'Email Rules'}><AddEmailRules /></ProtectedRoute>} />
                <Route path={`${UrlPath.EditEmailRules}:RuleId`} element={<ProtectedRoute name={'Email Rules'}><EditEmailRules /></ProtectedRoute>} />
                {/* Asset-- Valuation */}
                <Route path={`${UrlPath.Valuation}:AssetId`} element={<Valuation />} />
                <Route path={`${UrlPath.Duediligence}:AssetId`} element={<Duediligence />} />

                        {/* Asset-- Exposures */}
                        <Route path={`${UrlPath.Exposures}:Asset`} element={<ProtectedRoute name={'Exposures'}><AnalystExposure /></ProtectedRoute>} />
                        <Route path={`${UrlPath.AnalystExposure}:Asset`} element={<ProtectedRoute name={'Exposures'}><AnalystExposure /></ProtectedRoute>} />
                        <Route path={`${UrlPath.PrivateExposure}:Asset`} element={<ProtectedRoute name={'Exposures'}><PrivateExposure /></ProtectedRoute>} />
                        <Route path={`${UrlPath.PublicExposure}:Asset`} element={<ProtectedRoute name={'Exposures'}><PublicExposure /></ProtectedRoute>} />

                        {/* Documents */}
                        <Route path={`${UrlPath.Documents}`} element={<ProtectedRoute name={'Documents'}><Investment /></ProtectedRoute>} />
                        <Route path={`${UrlPath.DocumentsInvestment}`} element={<ProtectedRoute name={'Investment'}><Investment /></ProtectedRoute>} />
                        <Route path={`${UrlPath.DocumentsInvestmentEdit}:ActivityId`} element={<InvestmentEdit />} />
                        <Route path={`${UrlPath.DocumentsInvestmentAdd}`} element={<InvestmentAddView />} />

                        {/* Investor */}
                        <Route path={`${UrlPath.DocumentInvestor}`} element={<Investor />} />
                        <Route path={`${UrlPath.DocumentInvestorAdd}`} element={<InvestorAdd />} />
                        <Route path={`${UrlPath.DocumentInvestorEdit}:ActivityId`} element={<InvestorEdit />} />

                        {/* Analytics & Reporting */}
                        <Route path={`${UrlPath.Analytics}`} element={<ProtectedRoute name={'Analytics'}><MarketDataList /></ProtectedRoute>} />
                        <Route path={`${UrlPath.AnalyticsReporting}`} element={<ProtectedRoute name={'Market Data'}><MarketDataList /></ProtectedRoute>} />
                        <Route path={`${UrlPath.UniverseMembers}:UniverseId`} element={<ProtectedRoute name={'Universe Analytics'}><UniverseDetails /></ProtectedRoute>} />
                        <Route path={`${UrlPath.UniverseAdd}`} element={<ProtectedRoute name={'Universe Analytics'}><UniverseDetailsAdd /></ProtectedRoute>} />
                        <Route path={`${UrlPath.UniverseEdit}:UniverseId`} element={<ProtectedRoute name={'Universe Analytics'}><UniverseDetailsEdit /></ProtectedRoute>} />
                        <Route path={`${UrlPath.UniverseAnalytics}:UniverseId`} element={<ProtectedRoute name={'Universe Analytics'}><UniverseAnalytics /></ProtectedRoute>} />
                        {/* Market Data */}
                        <Route path={`${UrlPath.MarketData}`} element={<ProtectedRoute name={'Market Data'}><MarketDataList /></ProtectedRoute>} />
                        <Route path={`${UrlPath.MarketDataDetails}:MarketIndexId`} element={<ProtectedRoute name={'Market Data'}><MarketDataDetails /></ProtectedRoute>} />
                        <Route path={`${UrlPath.MarketDataAdd}`} element={<ProtectedRoute name={'Market Data'}><MarketDataAdd /></ProtectedRoute>} />
                        <Route path={`${UrlPath.MarketDataEdit}:MarketIndexId`} element={<ProtectedRoute name={'Market Data'}><MarketDataEdit /></ProtectedRoute>} />
                        <Route path={`${UrlPath.MarketAnalytics}:MarketIndexId`} element={<ProtectedRoute name={'Market Data'}><MarketAnalytics /></ProtectedRoute>} />
                        <Route path={`${UrlPath.MarketAnalyticsPostPricing}:MarketIndexId`} element={<ProtectedRoute name={'Market Data'}><MarketAnalyticsPostPricing /></ProtectedRoute>} />
                        <Route path={`${UrlPath.MarketDataSettings}:MarketIndexId`} element={<ProtectedRoute name={'Market Data'}><MarketDataSettings /></ProtectedRoute>} />
                        {/* Peer Analytics  */}
                        <Route path={`${UrlPath.UniverseList}`} element={<ProtectedRoute name={'Peer Analytics'}><UniverseList /></ProtectedRoute>} />
                        <Route path={`${UrlPath.UniverseSearch}:MarketIndexId`} element={<ProtectedRoute name={'Universe Search'}><UniverseList /></ProtectedRoute>} />
                        <Route path={`${UrlPath.ProformaConstruction}`} element={<ProformaConstruction />} />
                        <Route path={`${UrlPath.NewProformaConstruction}`} element={<CreateNewProformas />} />
                        {/* Admin */}
                        <Route path={`${UrlPath.Permissions}`} element={<ProtectedRoute name={'Permissions'}> <Permissions /></ProtectedRoute>} />
                        <Route path={`${UrlPath.Admin}`} element={<ProtectedRoute name={'Admin'}><Permissions /></ProtectedRoute>} />
                        <Route path={`${UrlPath.UserPageTracking}`} element={<ProtectedRoute name={'User Page Tracking Report'}><UserPageTracking /></ProtectedRoute>} />
                        <Route path={`${UrlPath.Billing}`} element={<Billing></Billing>} />
                        <Route path={`${UrlPath.BillingPreview}:Id/:Date`} element={<BillingPreviewSection></BillingPreviewSection>} />
                        <Route path={`${UrlPath.MarketableSecuritiesFeed}`} element={<MarketableSecuritiesFeed />} />
                        <Route path={`${UrlPath.WebPortalSync}`} element={<WebPortalSync></WebPortalSync>} />
                        <Route path={`${UrlPath.UsersLastLogin}`} element={<ProtectedRoute name={'Users Last Login'}><UsersLastLogin /></ProtectedRoute>} />
                        <Route path={`${UrlPath.ClientReportingSettings}`} element={<ProtectedRoute name={'Client Reporting Settings'}><ClientReportingSettings /></ProtectedRoute>} />
                        <Route path={`${UrlPath.ApplicationSettings}`} element={<ProtectedRoute name={'Application Settings'}><ApplicationSettings /></ProtectedRoute>} />
                        <Route path={`${UrlPath.Classfications}`} element={<ProtectedRoute name={'Classifications'}><Classfications /></ProtectedRoute>} />
                        <Route path={`${UrlPath.Custodians}`} element={<ProtectedRoute name={'Custodians'}><Custodians /></ProtectedRoute>} />
                        <Route path={`${UrlPath.TrainModel}`} element={<ProtectedRoute name={'Train Model'}><TrainModel /></ProtectedRoute>} />
                        <Route path={`${UrlPath.ServerInfo}`} element={<ServerInfo />}></Route>
                        {/* <Route path={`${UrlPath.ClientWebsites}`} element={<ProtectedRoute name={'Client Websites'}><ClientWebsite/></ProtectedRoute>}></Route>*/}
                        <Route
                            path={`${UrlPath.ClientWebsites}`}
                            element={
                                <ProtectedRoute name={'Client Websites'}>
                                    <RequireAuth name={'ClientWebsitesAccess'}>
                                        <ClientWebsite />
                                    </RequireAuth>
                                </ProtectedRoute>

                    }
                />
                <Route path={`${UrlPath.Partnership}`} element={<ProtectedRoute name={'Partnership'}><Partnership/></ProtectedRoute> }></Route>
                <Route path={`${UrlPath.PartnershipSetup}`} element={<ProtectedRoute name={'Partnership Setup'}><PartnershipSetup/></ProtectedRoute> }></Route>
                <Route path={`${UrlPath.PPLISetup}`} element={<ProtectedRoute name={'PPLI Setup'}><PPLISetup></PPLISetup></ProtectedRoute>}></Route>
                <Route path={`${UrlPath.DDQSetup}`} element={<ProtectedRoute name={'DDQ Setup'}><DDQSetup/></ProtectedRoute>}></Route>
                {/* Investor */}
                <Route path={`${UrlPath.Investor}`} element={<ProtectedRoute name={'Investor'}><CompanyContactsList /></ProtectedRoute>} />
                <Route path={`${UrlPath.Investment}:AssetId`} element={<ProtectedRoute name={'Inv Contact'}><CompanyContactsList /></ProtectedRoute>} />
                <Route path={`${UrlPath.InvestorDetails}:ContactId`} element={<ProtectedRoute name={'Details'}><Details /></ProtectedRoute>} />
                <Route path={`${UrlPath.InvestorLists}`} element={<ProtectedRoute name={'Lists'}><Lists /></ProtectedRoute>} />
                <Route path={`${UrlPath.InvestorDetailsEdit}:ContactId`} element={<ProtectedRoute name={'Details'}><ContactsEdit /></ProtectedRoute>} />
                <Route path={`${UrlPath.CompanyDetails}:CompanyId`} element={<ProtectedRoute name={'Details'}><CompanyDetails /></ProtectedRoute>} />
                <Route path={`${UrlPath.CompanyDetailsEdit}:CompanyId`} element={<ProtectedRoute name={'Details'}><CompanyEdit /></ProtectedRoute>} />
                <Route path={`${UrlPath.InvestorTracking}`} element={<InvestorTrackingList />}></Route>
                <Route path={`${UrlPath.InvestorAccounts}`} element={<InvestorAccounts />}></Route>
                <Route path={`${UrlPath.InvestorAccountDetails}:EntityID`} element={<InvestorAccountsDetails />}></Route>
                <Route path={`${UrlPath.InvestorAccountEdit}:EntityID`} element={<InvestorAccountEdit />}></Route>
                <Route path={`${UrlPath.InvestorAccountAdd}`} element={<InvestorAccountAdd />}></Route>
                <Route path={`${UrlPath.Tasks}`} element={<ProtectedRoute name={'Tasks'}><Tasks /></ProtectedRoute>} />
                <Route path={`${UrlPath.ClientStatements}`} element={<ProtectedRoute name={'Client Statement'}><CSDetails /></ProtectedRoute>} /> 
                <Route path={`${UrlPath.Opportunities}`} element={<ProtectedRoute name={'Opportunities'}><Opportunities /></ProtectedRoute>} />
                <Route path={`${UrlPath.EmailMarketing}`} element={<ProtectedRoute name={'Client Statement'}><EmailMarketing /></ProtectedRoute>} /> 
                {/* Portfolio*/}
                <Route path={`${UrlPath.PortfolioValuation}:AssetId`} element={<Valuation />} />
                <Route path={`${UrlPath.PortfolioList}`} element={<PortfolioList />} />
                <Route path={`${UrlPath.PortfolioDetails}:PortfolioId`} element={<PortfolioDetails />} />
                <Route path={`${UrlPath.PortfolioLiquidity}`} element={<ProtectedRoute name={'Details'}><Liquidity /></ProtectedRoute>}/>
                <Route path={`${UrlPath.AssetAllocation}:PortfolioId`} element={<><AssetAllocation /></>}/>
                <Route path={`${UrlPath.PortfolioPerfAndStats}`} element={<ProtectedRoute name={'Performance & Statistics'}><PerfAndStats/></ProtectedRoute>}/>
               
               
            
                <Route path={`${UrlPath.PortfolioAttribution}:PortfolioId`} element={<PortfolioAttribution />} />
                <Route path={`${UrlPath.PortfolioPricing}`} element={<Pricing />} />
                <Route path={`${UrlPath.PortfolioAssetAum}`} element={<AssetAUMList />} />
                <Route path={`${UrlPath.Reports}`} element={<Reporting />} />
                <Route path={`${UrlPath.standardReports}`} element={<Reporting />} />
                <Route path={`${UrlPath.ValuationPostPricing}:AssetId`} element={<ValuationPostPricing />} />
                <Route path={`${UrlPath.MarketablePostPricing}:AssetId`} element={<MarketablePostPricing />} />



                        {/* Portfolio transaction section */}
                        <Route path={`${UrlPath.portfolioTransaction}:PortfolioId`} element={< PortfolioTransaction />} />
                        <Route path={`${UrlPath.portfolioTransactionCommitment}:TransId/:EntityId/:ObjectType`} element={<Commitment />} />
                        <Route path={`${UrlPath.PortfolioAllocation}:TransId/:EntityId/:ObjectType`} element={<Allocation />} />
                        <Route path={`${UrlPath.PortfolioCapitalcall}:TransId/:EntityId/:ObjectType`} element={<CapitalCall />} />
                        <Route path={`${UrlPath.PortfolioJournalEntry}:TransId/:EntityId/:ObjectType`} element={<JournalEntry />} />
                        <Route path={`${UrlPath.PortfolioReceiveCash}:TransId/:EntityId/:ObjectType`} element={<ReceiveCash />} />
                        <Route path={`${UrlPath.PortfolioRedemption}:TransId/:EntityId/:ObjectType`} element={<Redemption />} />
                        <Route path={`${UrlPath.PortfolioAddToPortfolio}:TransId/:EntityId/:ObjectType`} element={<AddToPortfolio />} />
                        <Route path={`${UrlPath.PortfolioPayout}:TransId/:EntityId/:ObjectType`} element={<Payout />} />
                        <Route path={`${UrlPath.PortfolioDistribution}:TransId/:EntityId/:ObjectType`} element={<Distribution />} />
                        {/* asset transaction section */}

                <Route path={`${UrlPath.Transactions}:AssetId`} element={<ProtectedRoute name={'Transactions'}><TransactionList /></ProtectedRoute>} />
                <Route path={`${UrlPath.Commitment}:TransId/:EntityId/:ObjectType`} element={<Commitment />} />
                <Route path={`${UrlPath.Allocation}:TransId/:EntityId/:ObjectType`} element={<Allocation />} />           
                <Route path={`${UrlPath.AddToPortfolio}:TransId/:EntityId/:ObjectType`} element={<AddToPortfolio />} />
                <Route path={`${UrlPath.Redemption}:TransId/:EntityId/:ObjectType`} element={<Redemption />} />
                <Route path={`${UrlPath.Distribution}:TransId/:EntityId/:ObjectType`} element={<Distribution />} />
                <Route path={`${UrlPath.ReceiveCash}:TransId/:EntityId/:ObjectType`} element={<ReceiveCash />} />
                <Route path={`${UrlPath.Payout}:TransId/:EntityId/:ObjectType`} element={<Payout />} />
                <Route path={`${UrlPath.AssetCapitalcall}:TransId/:EntityId/:ObjectType`} element={<CapitalCall />} />
                <Route path={`${UrlPath.AssetJournalEntry}:TransId/:EntityId/:ObjectType`} element={<JournalEntry />} />
                
                {/* Investor Tracking */}
                <Route path={`${UrlPath.InvestorTrackingSubscription}:InvestorTrackingId`} element={<ITSubscription/>}/>
                <Route path={`${UrlPath.InvestorTrackingRedemption}:InvestorTrackingId`} element={<ITRedemption/>}/>
                <Route path={`${UrlPath.InvestorTrackingCommitment}:InvestorTrackingId`} element={<ITCommitment/>}/>
                <Route path={`${UrlPath.InvestorTrackingCapitalCall}:InvestorTrackingId`} element={<ITCapitalCall/>}/>
                <Route path={`${UrlPath.InvestorTrackingDistribution}:InvestorTrackingId`} element={<ITDistribution />} />
                <Route path={`${UrlPath.InvestorTrackingRedeemFee}:InvestorTrackingId`} element={<ITRedeemFee/>} />
                 <Route path={`${UrlPath.InvestorTrackingRedeemReallocate}:InvestorTrackingId`} element={<ITRedeemReallocate />} />
                <Route path={`${UrlPath.InvestorTrackingBulkUpload}`} element={<BulkUpload />} />
                <Route path={`${UrlPath.Settings}`} element={<Settings/>}/>
                    <Route path={`${UrlPath.MonitoringException}`} element={<MonitoringView />} />
                    <Route path={`${UrlPath.MonitoringExceptionSettings}`} element={<MonitoringSettingsView />} />
                    <Route path={`${UrlPath.MonitoringExceptionType}`} element={<MonitoringExceptionType />} />
                    <Route path={`${UrlPath.MonitoringNotificationDetails}`} element={<MonitoringNotificationDetails />}></Route>
                    <Route path={`${UrlPath.ChatBotUsageLogs}`} element={<ProtectedRoute name={'ChatBot Usage Logs'}><GenAITabs /></ProtectedRoute>}/>
                   
                   
                    <Route path={`${UrlPath.ClientReturnList}`} element={<><ClientReturnsList /></>}/>
                    <Route path={`${UrlPath.ClientReturnDetails}`} element={<><CilentReturnsDetails /></>}/>
                    <Route path={`${UrlPath.ClientReturnAnalytics}`} element={<><CilentReturnsAnalytics /></>}/>
                    
                    
                    <Route path={`${UrlPath.ThirdPartyData}`} element={<><ThirdPartyData /></>}/>
                    <Route path={`${UrlPath.ThirdPartyDataDetails}:EntityId`} element={<><ThirdPartyDataDetails /></>}/>
                    <Route path={`${UrlPath.ThirdPartyDataAnalytics}:EntityId`} element={<><ThirdPartyDataAnalytics /></>}/>
               
                    <Route path={`${UrlPath.PThirdPartyData}:EntityId`} element={<><ThirdPartyData /></>}/>
                    <Route path={`${UrlPath.PThirdPartyDataDetails}:EntityId`} element={<><ThirdPartyDataDetails /></>}/>
                    <Route path={`${UrlPath.PThirdPartyDataAnalytics}:EntityId`} element={<><ThirdPartyDataAnalytics /></>}/>
                    <Route path={`${UrlPath.AdminNotification}`} element={<><NotificationConsole /></>}/>
               
                {/* Error */}
                <Route path="*" element={<ErrorPage />} />
            </Route>
           
        </Routes>
        <><NotificationComponent show={showNotification} setShow={setShowNotification}/></>
        {viewAccess && <ChatBot chatAccess={chatAccess}/>}
        <NotificationDrawer notifcations={notifications} setNotifications={setNotifications} setShowDrawer={setShowNotificationDrawer}  showDrawer={showNotificationDrawer}   />
        </NotificationContext.Provider>}
        </>
    )
};
const updatePageTracking = (landingPage) => {
    const localToken = localStorage?.getItem('entryKey');
    const signalRConnectionId = localStorage?.getItem('signalRConnectionId');
    const sessionID = localToken?.split("")?.reverse()?.join("")?.substring(0, 23) || '000000000000000000000000';
    const data = {
        "createdBy": 0,
        "fromIP": "",
        "accessedRoute": getPageUrl(landingPage),
        "browserUsed": getBrowserName(),
        "additionalInfo": null,
        "sessionId": signalRConnectionId
    }
    sbaAxios({ url: updatePageTrackingAPI, data: data, method: 'post' });
}
const getBrowserName = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf("Firefox") > -1) {
        return "Mozilla Firefox";
    } else if (userAgent.indexOf("Chrome") > -1) {
        return "Google Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
        return "Internet Explorer";
    } else if (userAgent.indexOf("Edge") > -1) {
        return "Microsoft Edge";
    } else {
        return "Unknown";
    }
};
const getPageUrl = (landingPage) => {
    const pathName = window.location.pathname
    if (pathName === '/')
        return `/${landingPage ? landingPage : ''}`;
    else
        return pathName;
};




export const useNotification = () => useContext(NotificationContext);